import React from 'react'
import { AiFillCloseCircle } from 'react-icons/ai';
import { Box, Modal } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DIALOG_MARGIN, DIALOG_RADIUS, DIALOG_WIDTH, DIALOG_MOBILE_BREAKPOINT } from 'themes/theme';

// Mirrors the MuiDialog theme override: full-bleed on phones, the caller's
// maxWidth cap only applies from the breakpoint up.
const MOBILE_FULL_WIDTH = {
    [`@media (max-width:${DIALOG_MOBILE_BREAKPOINT - 0.05}px)`]: {
        width: DIALOG_WIDTH,
        maxWidth: DIALOG_WIDTH,
    },
};

function ModalComponent({ open, onClose, closeIcon=false, children, mxclass, style={}, sx={} }) {
    const theme = useTheme()
    // Clamp the caller's width so the modal can never touch the viewport edges,
    // while its maxWidth cap (from `style`) still applies on larger screens.
    const { width: requestedWidth = '900px', ...restStyle } = style;
    const width = typeof requestedWidth === 'number' ? `${requestedWidth}px` : requestedWidth;
    return (
        <Modal open={open} onClose={onClose} className={mxclass} sx={{...sx}}>
            {/* the child popups render their own Paper, so the radius is forced
                on it too — keeps every Modal matching the Dialog corners. */}
            <Box className='cs-modal' sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', ...restStyle, width: `min(${width}, ${DIALOG_WIDTH})`, maxHeight: `calc(100% - ${DIALOG_MARGIN * 2}px)`, overflowY: 'auto', borderRadius: `${DIALOG_RADIUS}px`, '& > .MuiPaper-root': { borderRadius: `${DIALOG_RADIUS}px` }, ...MOBILE_FULL_WIDTH }}>
                {closeIcon && <Box sx={{ position: 'absolute', top: '0px', right: '0px', padding: '15px', cursor: 'pointer',zIndex: 1 }} onClick={onClose} className='cs-close'>
                    <AiFillCloseCircle size={25}  />
                </Box>}
               {children}
            </Box>
        </Modal>
    )
}

export default ModalComponent